import React, { useEffect } from 'react'

const Reviews = () => {
    useEffect(() => {
        document.title = "CareerGrads | Testimonials"
    }, [])
    return (
        <div className="container">
            <div className="text-center">
                <h1>
                    Reviews
                </h1>
            </div>
            <div className="row">
                <div className="col-10 mx-auto ">

                </div>
            </div>
            {
                window.scrollTo(0, 0)
            }
        </div>
    )
}

export default Reviews
